import { render } from "./FootballView.vue?vue&type=template&id=2f6b3490&scoped=true"
import script from "./FootballView.vue?vue&type=script&lang=js"
export * from "./FootballView.vue?vue&type=script&lang=js"

import "./FootballView.vue?vue&type=style&index=0&id=2f6b3490&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f6b3490"]])

export default __exports__